var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"flex_left flex_nowrap"},[_c('span',{staticClass:"point flex_shrink0",style:({background: _vm.color || _vm.getColorHash(_vm.value)})},[_c('span',[_vm._v(_vm._s(_vm.value))])])]):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }